import { App } from "./ui.ts";
import { isDiscordActivity, signInWithDiscord } from "./discord.ts";
import { getIdentity, type Identity } from "./identity.ts";
import { LocalTransport, WebSocketTransport, type Transport } from "./transport.ts";

function showFatal(message: string, detail?: string): void {
  const stage = document.getElementById("stage")!;
  stage.innerHTML = "";
  const box = document.createElement("div");
  box.className = "fatal";
  box.innerHTML = `<h2></h2><p></p><small></small>`;
  box.querySelector("h2")!.textContent = message;
  box.querySelector("p")!.textContent = "Close the activity and open it again. If this keeps happening, tell whoever runs the table.";
  box.querySelector("small")!.textContent = detail ?? "";
  stage.append(box);
}

async function start(): Promise<void> {
  const params = new URLSearchParams(location.search);
  const wsBase = `${location.protocol === "https:" ? "wss" : "ws"}://${location.host}`;

  let identity: Identity;
  let transport: Transport;
  let autoSit = false;

  if (isDiscordActivity()) {
    // Running inside Discord: sign in with Discord, and share a table with everyone in this Activity.
    try {
      const session = await signInWithDiscord();
      identity = session.identity;
      const t = encodeURIComponent(session.tableId);
      // Discord proxies same-origin paths via our URL mapping; some setups need the /.proxy prefix, so try both.
      transport = new WebSocketTransport([`${wsBase}/ws/${t}`, `${wsBase}/.proxy/ws/${t}`]);
    } catch (e) {
      showFatal("Couldn't sign in with Discord.", e instanceof Error ? e.message : String(e));
      return;
    }
  } else if (params.has("demo") || location.protocol === "file:") {
    // ?demo runs a whole table (with bots) inside this tab, no server needed.
    identity = getIdentity();
    transport = new LocalTransport({ bots: Number(params.get("bots") ?? 5) });
    autoSit = !params.has("nosit"); // add ?nosit to see the buy-in dialog instead
  } else {
    // Plain browser tab talking to a real table server (npm run dev / your deployed site).
    identity = getIdentity();
    transport = new WebSocketTransport([`${wsBase}/ws/${encodeURIComponent(params.get("table") || "main")}`]);
  }

  const app = new App(identity, transport, { autoSit });
  (window as unknown as { __wg: App }).__wg = app;
}

void start();
